module.exports = __webpack_public_path__ + "img/target.d12bfc31.svg";